import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import { URL_IMG } from '../../../configs/urlConfigs';
import { MSG_ERROR,MSG_NOT_FOUND, MSG_APPAYRATE_CATEGORY_REQUIRED, MSG_APPAYRATE_FROM_REQUIRED, MSG_APPAYRATE_TO_REQUIRED, MSG_APPAYRATE_RATE_REQUIRED, MSG_APPAYRATE_ADD_SUCCESS, MSG_APPAYRATE_UPDATE_SUCCESS, MSG_APPAYRATE_DELETE_SUCCESS,MSG_APPAYRATE_ADD_EDIT_DUPLICATE, MSG_APPAYRATE_MISMATCH, MSG_PAY_RATE_DELETE, MSG_APCATEGORY_ADD_EDIT_DUPLICATE } from '../../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_SETTINGS, LBL_APPAYRATE, LBL_BTN_ADDNEW, LBL_SLNUM, LBL_AP_CATEGORY, LBL_AP_FROM, LBL_AP_TO, LBL_RATE, LBL_EDIT, LBL_DELETE, LBL_APPAYRATE_ADD, LBL_APPAYRATE_EDIT,LBL_CONFIRM_DELETE} from '../../../configs/labelConfigs';
import { ROUTE_AFFILIATE_REFRESH,ADD_TYPE, UPDATE_TYPE, DELETE_TYPE, LIST_TYPE } from '../../../configs/staticConfigs';

import ModalWindow from '../../commons/helpers/modalWindow';
import Toast from '../../commons/helpers/toast';

import { formValid, checkNumDot, checkNumDotZero } from '../../../utils/validation';


import { aflt_appayrateListAction, aflt_appayrateAddAction, aflt_appayrateUpdateAction, aflt_appayrateDeleteAction } from '../../../actions/settings/affiliates/aflt_appayrateActions';

import {clearAction} from '../../../actions/commonActions';

class APPPointsComponent extends Component { 

    constructor(props){
        super(props)

        this.state = {
            formErrors : {}, 
            appayratesList: [], 
            appayrateId: 0,
            appayrateCategory: '', 
            appayrateFrom: 0, 
            appayrateTo: 0,
            appayrateRate: 0, 
            activeRowId: 0, 
            appayrateData: {},
            formErrMsg_category: '', 
            formErrMsg_rateFrom: '',
            formErrMsg_rateTo: '',
            formErrMsg_rate: '',
            sortField:'ap_from',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        // this.onSort = this.onSort.bind(this);
        this.checkFormData = this.checkFormData.bind(this); 
        this.modalDelete = React.createRef();
        this.modal = React.createRef();
    }

    componentDidMount() { 
        document.body.classList.add('body-affiliate'); 
        document.title = LBL_APP_NAME+' - '+LBL_SETTINGS+' - Set '+LBL_APPAYRATE; 
        this.props.aflt_appayrateListAction(); 
    }   
    
    openModal(refId) {
        if(!refId) {
            this.setState({appayrateId:0, appayrateCategory:'', appayrateFrom:0, appayrateTo:0, appayrateRate:0, formErrMsg_category:'', formErrMsg_rateFrom:'', formErrMsg_rateTo:'', formErrMsg_rate:''});
        } 
        this.modal.current.handleOpenModal();
    }  

    onModalFormReset = () =>{   
        this.setState({appayrateId:0, appayrateCategory:'', appayrateFrom:0, appayrateTo:0, appayrateRate:0, formErrMsg_category:'', formErrMsg_rateFrom:'', formErrMsg_rateTo:'', formErrMsg_rate:''});   
        this.props.clearAction();  
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }  

    onShowActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }        
    }   
    
    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSort = (event,sortKey) =>{        
        let sOrder = '';
        if(this.state.sortField===sortKey){         
            sOrder = (this.state.sortOrder==='-') ? '' : '-';
            this.props.aflt_appayrateListAction({column:sOrder+this.state.sortField});
            this.setState({ sortOrder:sOrder });            
        }else{
            this.setState({ sortField:sortKey });
            this.props.aflt_appayrateListAction({column:this.state.sortOrder+sortKey});
        }        
    }

    editBtnClick = (refId) =>{  
        this.props.appayratesList.map((rObj) => {
            if(refId===rObj.id) {
                this.setState({appayrateId:refId, appayrateCategory:rObj.name, appayrateFrom:rObj.ap_from, appayrateTo:rObj.ap_to, appayrateRate:rObj.pay_rate, formErrMsg_category:'', formErrMsg_rateFrom:'', formErrMsg_rateTo:'', formErrMsg_rate: ''});
                this.openModal(refId); 
            }
            return console.log('edit'); 
        }); 
    }

    deleteBtnClick = (rowId) =>{
        this.setState({appayrateId: rowId}); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        this.props.aflt_appayrateDeleteAction(this.state.appayrateId);
        this.modalDelete.current.handleModelClose();              
    }
    
    onHandleChange = (event) =>{
        const {name, value} = event.target; 
        let errMsg = ''; 
        let valStr = value.trim(); 
        // appayrateId  
        if(name==='txt_category') { 
            if(valStr==='')  {
                errMsg = MSG_APPAYRATE_CATEGORY_REQUIRED; 
            }
            this.setState({appayrateCategory:valStr, formErrMsg_category:errMsg});  
        } 
        else if(name==='txt_appayrateFrom') { 
            if(!checkNumDotZero(valStr) || valStr===0 || valStr==='')  {
                valStr = (valStr===0) ? 0 : '';
                errMsg = MSG_APPAYRATE_FROM_REQUIRED; 
            }
            this.setState({appayrateFrom:valStr, formErrMsg_rateFrom:errMsg});  
        } 
        else if(name==='txt_appayrateTo') {
            if(!checkNumDotZero(valStr) || valStr===0 || valStr==='')  {
                valStr = (valStr===0) ? 0 : '';
                errMsg = MSG_APPAYRATE_TO_REQUIRED; 
            }
            this.setState({appayrateTo:valStr, formErrMsg_rateTo:errMsg});  
        } 
        else if(name==='txt_appayrateRate') {
            if(!checkNumDotZero(valStr) || valStr===0 || valStr==='')  {
                valStr = (valStr===0) ? 0 : '';
                errMsg = MSG_APPAYRATE_RATE_REQUIRED; 
            }
            this.setState({appayrateRate:valStr, formErrMsg_rate:errMsg});  
        } 
    }  

    checkFormData() {
        if(this.state.appayrateCategory.trim()==='') {   
            this.setState({formErrMsg_category:MSG_APPAYRATE_CATEGORY_REQUIRED});  
            return false; 
        }
        else if(!checkNumDot(this.state.appayrateFrom) || parseFloat(this.state.appayrateFrom)===0) {  
            this.setState({formErrMsg_rateFrom:MSG_APPAYRATE_FROM_REQUIRED});  
            return false; 
        } 
        else if(!checkNumDot(this.state.appayrateTo) || parseFloat(this.state.appayrateTo)===0) {
            this.setState({formErrMsg_rateTo:MSG_APPAYRATE_TO_REQUIRED});  
            return false; 
        } 
        else if(!checkNumDot(this.state.appayrateRate) || parseFloat(this.state.appayrateRate)===0) {
            this.setState({formErrMsg_rate:MSG_APPAYRATE_RATE_REQUIRED});  
            return false; 
        } 
        else if(parseFloat(this.state.appayrateFrom) > parseFloat(this.state.appayrateTo)) {
            this.setState({formErrMsg_rateTo:MSG_APPAYRATE_MISMATCH});  
            return false; 
        } 
        else {
            return true; 
        }
    }

    onSaveFormData = (refId) =>{
        if(formValid(this.state)){
            let userGroupData = userGroupUrlCheck(this.props.location);
            let grpProfileId = '';
            if(userGroupData!==undefined){
                grpProfileId = userGroupData.profile_id;
            }
            let category = this.state.appayrateCategory;   
            let refFrom = parseFloat(this.state.appayrateFrom);   
            let refTo   = parseFloat(this.state.appayrateTo);  
            let refRate = parseFloat(this.state.appayrateRate);  
            if(refId){ // EDIT 
                if(this.checkFormData()) { 
                    let foundData = 0; 
                    this.props.appayratesList.forEach((rObj) => {
                        if(foundData===0) { 
                            if(refId!==rObj.id && (category.trim().toLowerCase()===rObj.name.trim().toLowerCase()) ) {
                                foundData = 2; 
                            }
                            else if(refId!==rObj.id && (
                                (refFrom >= parseFloat(rObj.ap_from)  && refFrom <= parseFloat(rObj.ap_to)) || 
                                (refTo >= parseFloat(rObj.ap_from)  && refTo <= parseFloat(rObj.ap_to)) || 
                                (refFrom < parseFloat(rObj.ap_from)  && refTo > parseFloat(rObj.ap_to))  )
                            ) { 
                                foundData = 1;  
                            }
                        }
                    }); 


                    if(foundData===2) { 
                        this.setState({formErrMsg_category:MSG_APCATEGORY_ADD_EDIT_DUPLICATE});
                    }
                    else if(foundData > 0) {
                        this.setState({formErrMsg_rateTo:MSG_APPAYRATE_ADD_EDIT_DUPLICATE});
                    }
                    else {
                        let affiliate = grpProfileId;
                        let tmpappayrateData= {
                            id: refId,
                            name: category, 
                            ap_from: refFrom,  
                            ap_to: refTo, 
                            pay_rate: refRate,  
                            affiliate: affiliate                                 
                        } 
                        this.props.aflt_appayrateUpdateAction(tmpappayrateData);
                        this.onModalFormReset();
                        this.modal.current.handleModelClose(); 
                    }
                }
            } else if(this.checkFormData()) {
                // appayrateFrom appayrateTo appayrateRate 
                let foundData = 0; 
                if(this.props.appayratesList.length===0) {
                    foundData = 0; 
                }
                else { 
                    this.props.appayratesList.forEach((rObj) => {
                        if(foundData===0) { 
                            if( (category.trim().toLowerCase()===rObj.name.trim().toLowerCase()) ) {
                                foundData = 2; 
                            }
                            else if( 
                                (refFrom >= parseFloat(rObj.ap_from)  && refFrom <= parseFloat(rObj.ap_to)) || 
                                (refTo >= parseFloat(rObj.ap_from)  && refTo <= parseFloat(rObj.ap_to)) || 
                                (refFrom < parseFloat(rObj.ap_from)  && refTo > parseFloat(rObj.ap_to))  ) {
                                foundData = 1; 
                            }
                        }
                    }); 
                }
                
                if(foundData===2) { 
                    this.setState({formErrMsg_category:MSG_APCATEGORY_ADD_EDIT_DUPLICATE});
                }
                else if(foundData > 0) { // MSG_APCATEGORY_ADD_EDIT_DUPLICATE
                    this.setState({formErrMsg_rateTo:MSG_APPAYRATE_ADD_EDIT_DUPLICATE});
                }
                else {                    
                    let affiliate = grpProfileId;
                    let tmpappayrateData= {
                        id: refId, 
                        name: category, 
                        ap_from: refFrom,  
                        ap_to: refTo, 
                        pay_rate: refRate,  
                        affiliate: affiliate                                 
                    } 
                    this.props.aflt_appayrateAddAction(tmpappayrateData);
                    this.onModalFormReset();
                    this.modal.current.handleModelClose();
                }
            }    
        }else{
            // let formErrors = this.state.formErrors;
            // if(this.state.sectorData.sectorName==null){
            //     formErrors.sectorName = MSG_SECTOR_REQUIRED;
            // }            
            // this.setState({formErrors});
        }
    }

    componentDidUpdate(prevProps) {       
        const { status,activity} = this.props;

        if (status !== prevProps.status || activity!==prevProps.activity) {
            
            if(activity===LIST_TYPE){
                let newObj = [];
                if(this.props.hasOwnProperty('appayratesList')) newObj = this.props.appayratesList;
                this.setState({appayratesList:newObj}); 
            }
            else if(activity===ADD_TYPE){
                this.props.aflt_appayrateListAction();
                this.setState({toastFlag:true,toastMessage:MSG_APPAYRATE_ADD_SUCCESS}); 
                setTimeout(()=> {
                    this.onCloseToast();
                }, 3000);
            }else if(activity===UPDATE_TYPE){
                this.props.aflt_appayrateListAction();
                this.setState({toastFlag:true,toastMessage:MSG_APPAYRATE_UPDATE_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast();
                }, 3000);          
            }else if(activity===DELETE_TYPE){
                this.props.aflt_appayrateListAction();       
                this.setState({toastFlag:true,toastMessage:MSG_APPAYRATE_DELETE_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast();
                }, 3000);
            }else{
            }
        }else if (activity !== prevProps.activity) {
            
        }
    }
       
    render(){
        const { toastMessage,toastFlag,toastSuccess } = this.state

        const { status } = this.props;  
        let appayratesList = [];

        if(Array.isArray(this.state.appayratesList))  appayratesList = this.state.appayratesList; 
        
        let userGroupData = userGroupUrlCheck(this.props.location);
        let currStr = '';
        if(userGroupData!==undefined){
            currStr = userGroupData.profile_currency;
        }
  
        if(status===401 || status===403){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }

        return(

            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        
                        <div className="to-right">                                   
                            <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_BTN_ADDNEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{width:'100%'}}>
                                <thead>
                                    <tr>
                                        <th>{LBL_SLNUM}</th> 
                                        <th>{LBL_AP_CATEGORY} &nbsp;</th>
                                        <th>{LBL_AP_FROM} &nbsp;</th>
                                        <th>{LBL_AP_TO}</th>
                                        <th>{LBL_RATE} ({currStr})</th>
                                        <th className="action">&nbsp;</th>
                                        <th></th>
                                        {/* onClick={(e) => this.onSort(e,'ap_from')} className="sorting_asc" */}
                                    </tr>
                                </thead>
                                <tbody>
                                {(this.props.activity===LIST_TYPE) && (appayratesList) && appayratesList.length===0 && 
                                    <tr>
                                        <td colSpan="6" className="text-center">{(status===500) ?  MSG_ERROR : MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                
                                {(appayratesList) && appayratesList.map((item,index) => { 
                                    return (
                                        <tr key={item.id}>
                                            <td>{(index+1)}</td>
                                            <td>{item.name}</td>
                                            <td>{item.ap_from}</td>
                                            <td>{item.ap_to}</td>
                                            <td>{item.pay_rate}</td>
                                            <td>
                                                <div className="dropdown" id={'dropdown-'+item.id}>
                                                    <button className="dropdown-toggle" type="button" id={'dropdownMenuButton-'+item.id}  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  onClick={(e) => this.onShowActionButtons(e, item.id)} 
                                                    >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                    </button> 
                                                    <div className="dropdown-menu" aria-labelledby={'dropdownMenuButton-'+item.id} id={'dropdown-menu-'+item.id}>
                                                    <Link className="dropdown-item edit" to="#"  onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link>
                                                    <Link className="dropdown-item delete" to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id)}>{LBL_DELETE}</Link>
                                                    </div>
                                                </div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    )})}
                                    
                                </tbody>
                            </table>
                            <br />  
                            <div className="clear-b-scroll">&nbsp;</div>
                        </div>
                    </div>
                </div>


                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {MSG_PAY_RATE_DELETE}
                </ModalWindow>

                <ModalWindow ref={this.modal} header={!this.state.appayrateId?LBL_APPAYRATE_ADD:LBL_APPAYRATE_EDIT} saveFormData={ (e)=>this.onSaveFormData(this.state.appayrateId)} resetModalForm={this.onModalFormReset}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_AP_CATEGORY}</label>
                                <div className="text-input"> 
                                    <input type="text" placeholder="" name="txt_category" value={this.state.appayrateCategory} onChange={this.onHandleChange} className={this.state.formErrMsg_category.length > 0 ? "input-error" : ''} /></div>
                                {this.state.formErrMsg_category.length >0 && (
                                <div className="text-red left-align text-12">{this.state.formErrMsg_category}</div>
                                )} 
                            </div>
                        </div>  
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_AP_FROM}</label>
                                <div className="text-input"> 
                                    <input type="text" placeholder="" name="txt_appayrateFrom" value={this.state.appayrateFrom} onChange={this.onHandleChange} maxLength = {12} className={this.state.formErrMsg_rateFrom.length > 0 ? "input-error" : ''} /></div>
                                {this.state.formErrMsg_rateFrom.length >0 && (
                                <div className="text-red left-align text-12">{this.state.formErrMsg_rateFrom}</div>
                                )} 
                            </div>
                        </div>  

                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_AP_TO}</label> 
                                <div className="text-input"> 
                                    <input type="text" placeholder="" name="txt_appayrateTo" value={this.state.appayrateTo} onChange={this.onHandleChange} maxLength = {12} className={this.state.formErrMsg_rateTo.length > 0 ? "input-error" : ''} /></div>
                                {this.state.formErrMsg_rateTo.length >0 && (
                                <div className="text-red left-align text-12">{this.state.formErrMsg_rateTo}</div>
                                )} 
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_RATE} ({currStr})</label>
                                <div className="text-input"> 
                                    <input type="text" placeholder="" name="txt_appayrateRate" value={this.state.appayrateRate} onChange={this.onHandleChange} maxLength = {12} className={this.state.formErrMsg_rate.length > 0 ? "input-error" : ''}  /></div>
                                {this.state.formErrMsg_rate.length >0 && (
                                <div className="text-red left-align text-12">{this.state.formErrMsg_rate}</div>
                                )}
                            </div>
                        </div>
                    </div>

                </ModalWindow>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    console.log('state.afltAppayrate: '+JSON.stringify(state.afltAppayrate)); 
    return {
        appayratesList : state.afltAppayrate.items,
        status:state.afltAppayrate.status,
        activity:state.afltAppayrate.activity
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        aflt_appayrateListAction:aflt_appayrateListAction,  
        aflt_appayrateAddAction:data=>aflt_appayrateAddAction(data),
        aflt_appayrateUpdateAction:data=>aflt_appayrateUpdateAction(data),
        aflt_appayrateDeleteAction:id=>aflt_appayrateDeleteAction(id),
        clearAction:clearAction
    },dispatch);
} 
export default connect(mapStateToProps,mapDispatchToProps)(APPPointsComponent);

